import UtilityService from '@/services/UtilityService.js';
import ApplicationService from '@/services/ApplicationService.js';

export default {
    methods: {

        async getFundingTypes() {
            UtilityService.getSimpleApiData(this.accessToken, "funding_types")
            .then(response => {
             this.funding_types = response;
            })
        },
        async getApplicationData() {
      
            // Use the eventService to call the getEventSingle() method
            ApplicationService.getApplication(this.accessToken, this.$route.params.id)
            .then(
              (application => {
                this.$set(this, "application", application);
              }).bind(this)
            )
            .catch((error) => {
             this.notfound = 1
              console.log(error)
            });
      
            this.getGoverningBodies();
        },
        async getGoverningBodies() {
            UtilityService.getSimpleApiData(this.accessToken, "governing_bodies")
            .then(response => {
             this.governing_bodies = response;
            })
          },
          async getCouncilAreas() {
            UtilityService.getSimpleApiData(this.accessToken, "council_areas")
            .then(response => {
             this.council_areas = response;
            })
          },
    }
}